import { Navigate } from 'react-router-dom'
import { useAuthStore } from 'shared/store/authStore'
import CompanyRegisterModalContent from '../../components/auth/CompanyRegisterModalContent'

export default function CompanyRegister() {
  const customer = useAuthStore((s) => s.customer)
  const me = useAuthStore((s) => s.me)
  if (customer?.token && customer?.user && me?.has_company) {
    return <Navigate to="/company" replace />
  }

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4" data-testid="page-company-register">
      <div className="w-full max-w-md rounded-xl bg-white border border-slate-200 p-6 shadow-xl">
        <CompanyRegisterModalContent />
      </div>
    </div>
  )
}
